import React, { useState } from 'react';
import classNames from "classnames";

import { 
  Button, 
  Drawer, 
  Grid, 
  IconButton, 
  MenuItem
} from '@material-ui/core';

import { Close as CloseIcon, Person as AccountIcon } from '@material-ui/icons';

// components
import Widget from '../Widget/Widget';

// styles
import styleDrawer from '../../themes/drawer';
import Update from './actions/edit';
const useStyles = styleDrawer;

export default function TemporaryDrawer(props) {
  const classes = useStyles();
  const [state, setState] = useState({ right : false });

  let userProfile = [];
  if(props && props.dataUser && props.dataUser.user){
    userProfile = props.dataUser.user;
  }

  const toggleDrawer = (side, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [side] : open });
  };

  const sideList = () => (
    <div
      className={classes.boxDrawer}
      role="presentation"
    >
      <Grid container spacing={0} className={classes.containerDrawer}>
        <Grid item xs={12}>
          <div className={classes.drawerHead}>
            <Grid container spacing={0}>
              <Grid item xs={9}>
                <h2>
                  <IconButton onClick={toggleDrawer('right', false)}>
                    <CloseIcon />
                  </IconButton>
                  Profile
                </h2>
              </Grid>
              <Grid item xs={3}>
              <Button color="primary" variant="contained" fullWidth form="myForm" type="submit">SAVE</Button>
              </Grid>
            </Grid>
          </div>
          <div className={classes.drawerBody}>
            <Widget header={false}>
              <Update id = {userProfile.id} name = {userProfile.name} email = {userProfile.email} password = {userProfile.password}></Update>
              
            </Widget>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <>
      <MenuItem
        className={classNames(
          classes.profileMenuItem,
          classes.headerMenuItem,
        )}
        onClick={toggleDrawer('right', true)}
      >
        <AccountIcon className={classes.profileMenuIcon} /> Profile
      </MenuItem>
      <Drawer anchor="right" open={state.right} onClose={toggleDrawer('right', false)}>
        {sideList('right')}
      </Drawer>
    </>
  );
}